<div class="card_statistic card_graph_statistic h-100 mb-0" #ContainerRef>
  <div class="card_inner">
    <div class="card_header">
      <h4 class="card_title">{{ title }}</h4>
    </div>
    <div class="card_content" #InnerRef>
      <ng-container *ngIf="type === 'multi'">
        <ngx-charts-bar-vertical-2d [maxXAxisTickLength]="10" [roundDomains]="true" [barPadding]="0" [groupPadding]="5"
          [view]="[InnerRef.offsetWidth, 300]" [scheme]="colorScheme" [results]="values" [gradient]="gradient"
          [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="legend" [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
          [legendPosition]="legendPosition" [legendTitle]="legendTitle" (select)="onSelect($event)">
        </ngx-charts-bar-vertical-2d>
      </ng-container>

      <ngx-charts-pie-chart class="pie_chart" *ngIf="type === 'pie'" [view]="[InnerRef.offsetWidth, 300]"
        [scheme]="colorScheme" [results]="values" [gradient]="gradient" [legend]="legend" [labels]="showLabels"
        [doughnut]="isDoughnut" [legendTitle]="legendTitle" [labelFormatting]="formatDataLabel"
        [legendPosition]="legendPosition" (select)="onSelect($event)">
      </ngx-charts-pie-chart>

      <ng-container *ngIf="type === 'bar' || !type">
        <ngx-charts-bar-vertical [maxXAxisTickLength]="10" [roundDomains]="true" [view]="[InnerRef.offsetWidth, 300]"
          [scheme]="colorScheme" [results]="values" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
          [legend]="legend" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
          [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [legendPosition]="legendPosition"
          [legendTitle]="legendTitle" (select)="onSelect($event)">
        </ngx-charts-bar-vertical>
      </ng-container>

      <ng-container *ngIf="type === 'line'">
        <ngx-charts-line-chart class="line_chart" [maxXAxisTickLength]="10" [roundDomains]="true"
          [view]="[InnerRef.offsetWidth, 300]" [scheme]="colorScheme" [results]="values" [gradient]="gradient"
          [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="legend" [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [timeline]="true"
          [legendTitle]="legendTitle" [legendPosition]="legendPosition" (select)="onSelect($event)">
        </ngx-charts-line-chart>
        <!-- <ngx-charts-line-chart [view]="[InnerRef.offsetWidth, 300]" [scheme]="colorScheme" [legend]="legend"
          [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxis]="showXAxis" [yAxis]="showYAxis"
          [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [timeline]="true" [results]="multi"
          (select)="onSelect($event)">
        </ngx-charts-line-chart> -->
      </ng-container>
    </div>
  </div>

</div>